import SettingsAutomotive from 'scripts/defa/settings-automotive/model-settings-automotive';

/**
 * defa.collections.SettingsAutomotives
 * A Collection of SettingsAutomotives with custom filters.
 * @version 1.2.0
 */
const SettingsAutomotives = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model: SettingsAutomotive,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Returns a new SettingsAutomotives collection filtered by an array of ids.
	 * @param  {array}      ids  An array of ids to filter the collection by.
	 * @return {Collection}      The filtered SettingsAutomotiveCollection.
	 */
	filterByIds: function ( ids ) {
		let array = this.filter( function ( model ) {
			return _.contains( ids, model.get( 'id' ) );
		} );
		
		return new SettingsAutomotives( array );
	},
	
} );

export default SettingsAutomotives;